import { instance as axios } from '../axiosInstance';
import { statusHandler } from '../../utils/loginHelper';

const BASE = '/api/integracao/webhooks';

const getHeader = (token) => ({
  Authorization: `Bearer ${token}`,
});

export const listWebhooks = (token) =>
  axios.get(BASE, { validateStatus: statusHandler, headers: getHeader(token) });

export const createWebhook = (token, data) =>
  axios.post(BASE, data, { validateStatus: statusHandler, headers: getHeader(token) });

export const updateWebhook = (token, id, data) =>
  axios.put(`${BASE}/${id}`, data, { validateStatus: statusHandler, headers: getHeader(token) });

export const deleteWebhook = (token, id) =>
  axios.delete(`${BASE}/${id}`, { validateStatus: statusHandler, headers: getHeader(token) });

export const listWebhookEvents = (token, params = {}) =>
  axios.get(`${BASE}/eventos`, {
    validateStatus: statusHandler,
    headers: getHeader(token),
    params,
  });

export const getWebhookEvent = (token, id) =>
  axios.get(`${BASE}/eventos/${id}`, {
    validateStatus: statusHandler,
    headers: getHeader(token),
  });
